'use strict';

import './scss/kyrktak.scss';
import wp_kyrktak from './js/modules/wp-kyrktak.js';

$(document).ready(function($) {
  wp_kyrktak();
});
